import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportCommunicationContentModel} from '../reportCommunicationContent.model';
import {Injectable} from '@angular/core';
import {
    CommunicationContentModelConverter
} from '../../../../../communication/content-model/api/entity/converter/communicationContentModel.converter';

@Injectable({
    providedIn: 'root'
})
export class ReportCommunicationContentConverter extends HttpModelConverter<ReportCommunicationContentModel> {

    constructor(private contentModelConverter: CommunicationContentModelConverter) {
        super();
    }
    protected createInstance(): ReportCommunicationContentModel {
        return new ReportCommunicationContentModel();
    }

    protected enrichObject(result: ReportCommunicationContentModel, src: ReportCommunicationContentModel) {
        result.contentModel = this.contentModelConverter.convert(src.contentModel);
    }

}
